// extracted by mini-css-extract-plugin
export default {"surfaceBlock":"surfaceBlock_surfaceBlock__+QMY9","compact":"surfaceBlock_compact__NTKkL"};